// Purpose: Shared browser history instance for navigation outside React components (Redux actions)
// Caller: authAction, App.js
// Dependencies: history
// Main Functions: history (createBrowserHistory singleton)
// Side Effects: None

import { createBrowserHistory } from 'history'

const history = createBrowserHistory()

export default history
